export const HTML_WIDTH = window.innerWidth;
export const MAX_WIDTH = 1360;
export const DESKTOP_BREAKPOINT = 1024;
export const TABLET_BREAKPOINT = 768;
export const LOGGED_IN = !$('#body').hasClass('guest');
export const RELOAD_PAGE_ON_DESKTOP_BREAKPOINT = true;
export const TRIGGER_OVERLAY_ON_RELOAD_PAGE_ON_DESKTOP_BREAKPPOINT = true;
